import { UiRegionItem } from 'utils/cfUiItems/base';

/**
 * Image mask type guard
 */
export const isImageMaskRegion = (item: UiRegionItem): item is UiRegionItem => {
  if ('regionData' in item && 'mask' in item.regionData) {
    return true;
  }
  return false;
};

/**
 * Bbox region info type guard
 */
export const isBboxRegion = (region?: CF.API.RegionInfo): region is CF.API.BboxRegionInfo => !!region && 'bounding_box' in region;

/**
 * Polygon region info type guard
 */
export const isPolygonRegion = (region?: CF.API.RegionInfo): region is CF.API.PolygonRegionInfo => !!region && 'polygon' in region;

/**
 * Mask region info type guard
 */
export const isMaskRegion = (region?: CF.API.RegionInfo): region is CF.API.ImageMaskRegionInfo => !!region && 'mask' in region;

/**
 * Bbox shape props type guard
 */
export const isBboxShapeProps = (shapeProps: CF.API.ShapeProps): shapeProps is CF.API.BboxShapeProps => 'bbox' in shapeProps;

/**
 * Polygon shape props type guard
 */
export const isPolygonShapeProps = (shapeProps: CF.API.ShapeProps): shapeProps is CF.API.PolygonShapeProps => 'polygon' in shapeProps;

/**
 * Mask shape props type guard
 */
export const isMaskShapeProps = (shapeProps: CF.API.ShapeProps): shapeProps is CF.API.MaskShapeProps => 'mask' in shapeProps;

export const dataIsImage = (outputData: CF.API.TOutputData | CF.API.BaseOutputData): outputData is CF.API.BaseImageData => {
  return 'image' in outputData;
};

export const dataIsRegions = (outputData: CF.API.TOutputData | CF.API.BaseOutputData): outputData is CF.API.BaseRegionsData => {
  return 'regions' in outputData;
};

export const dataIsConcepts = (outputData: CF.API.TOutputData | CF.API.BaseOutputData): outputData is CF.API.BaseConceptsData => {
  return 'concepts' in outputData;
};

export const dataIsColors = (outputData: CF.API.TOutputData | CF.API.BaseOutputData | undefined): outputData is CF.API.BaseColorsData => {
  if (outputData) return 'colors' in outputData;
  return false;
};

export const dataIsText = (outputData: CF.API.TOutputData | CF.API.BaseOutputData): outputData is CF.API.BaseTextData => {
  return 'text' in outputData;
};

export const dataIsFrames = (outputData: CF.API.TOutputData | CF.API.BaseOutputData): outputData is CF.API.BaseFramesData => {
  return 'frames' in outputData;
};
